import React from 'react';
import { Navigate } from 'react-router-dom';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import CircularIndex from '@routes/Home/routes/Curriculum/routes/DashboardHome/Circular/routes/CircularIndex';
import CircularDetails from '@routes/Home/routes/Curriculum/routes/DashboardHome/Circular/routes/CircularDetails';
import CreateCircular from './CreateCircular';
import EditCircular from './EditCircular';

const CircularDashboardLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'CircularDashboard' */ './components/Circular')
);

export default (store) => {
	return [
		{
			path: 'home/circular-dashboard',
			element: <Navigate to="inbox" replace />,
		},
		{
			path: 'home/circular-dashboard/:view',
			element: (
				<AsyncLoading
					component={
						<CircularDashboardLazy
							featureFlag="Module:Announcement"
							permission="CanViewAnnouncements"
						/>
					}
				/>
			),
			children: [CircularIndex(store), CircularDetails(store)],
		},
		CreateCircular(store),
		EditCircular(store),
	];
};
